import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  return children;
};

export default AdminRoute;
